import { onBannedErrorMiddleware } from "@kunduz/utility-axios/bannedErrorMiddleware";
import { apiClient } from "@kunduz/utility-axios/networkClient";
import axios from "axios";

export function getCoreApiNetworkClient(options: {
  token?: string;
  isoCode?: string;
  webSecretKey?: string;
}) {
  return apiClient;
}
